import { axiosV1 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

import { EncumbrancesBulkItemPayload } from 'modules/_shared/components/Modals/EncumbrancesExcel/utils/encumbrancesExcelImportHelpers';

export type CreateEncumbrancesBulkBody = {
  societyId: string;
  encumbrances: EncumbrancesBulkItemPayload[];
};

export type CreateEncumbrancesBulkResultItem = {
  encumbranceId: string;
  success: boolean;
  error?: string;
};

export type CreateEncumbrancesBulkResponse = {
  created: number;
  failed: number;
  results: CreateEncumbrancesBulkResultItem[];
};

export const createEncumbrancesBulk = async (
  body: CreateEncumbrancesBulkBody
): Promise<CreateEncumbrancesBulkResponse> => {
  const { data } = await axiosV1.post('/encumbrances/bulk', body);

  const decodedData = (await decryptResponse(
    data
  )) as CreateEncumbrancesBulkResponse;

  return decodedData;
};
